import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";
import http from "../http";
import { TijdlijnDatumType, TijdlijnTaakType } from "../enums";

export interface ActiveDossier {
  kenmerk: string;
  naam: string;
  artsen: string;
  assistenten: string;
  fase: "DATUM" | "TAAK" | "WACHTEN" | null;
  deadline: string | null;
  /** Datum onderzoek (ONDERZOEK), ISO string. For display: dd-mm-yyyy */
  datumOnderzoek?: string | null;
  /** Concatenated note bodies for search/filter only (not displayed in table) */
  notities?: string;
  /** Date milestones present in timeline, for phase dots */
  faseDatumTypes?: TijdlijnDatumType[];
  /** Open task summaries for dashboard inline task display */
  openTaken?: {
    id: string;
    taakType: TijdlijnTaakType | null;
    assigneeShort: string | null;
    vervalDatum: string | null;
  }[];
}

export const useActiveDossiers = () => {
  const { user } = useAuth();

  return useQuery<ActiveDossier[]>({
    queryKey: ["activeDossiers", user?.id],
    queryFn: async (): Promise<ActiveDossier[]> => {
      const response = await http.get<ActiveDossier[]>("/dossiers/active");
      return response.data;
    },
    enabled: !!user,
    staleTime: 30_000,
    gcTime: 2 * 60_000,
  });
};
